import { render } from "./SurveyHome.vue?vue&type=template&id=a42805c8"
import script from "./SurveyHome.vue?vue&type=script&lang=js"
export * from "./SurveyHome.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sahanakumari/Documents/GitHub/zsurvey-app/zsurvey-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__